import { Grid, IconButton } from "@mui/material";
import { useCallback, useEffect, useState } from "react";

import TableCM from "components/shared/Table";
import DrawerCM from "components/shared/Drawer";
import GenarateHeadCell from "helper/generate-head-cell";
import useHttp from "hooks/use-http";
import { deleteDiscountRequest, getDiscountRequest } from "api/requests";
import PaginationCM from "components/shared/Pagination";
import LoadingCM from "components/shared/Loading";
import spliter from "helper/digit-spliter";
import { PAGINATION_LIMIT } from "constants";
import { MdDelete } from "react-icons/md";
import Toast from "helper/toast";

const headCells = GenarateHeadCell("discount");
let initialPage = 1;

export default function Discount() {
  const [discount, setDiscount] = useState({ data: [], count: 0 });
  const { request, loading } = useHttp();
  const [page, setPage] = useState(initialPage);

  const getDiscount = useCallback(async () => {
    const res = await request({
      url: getDiscountRequest,
      values: { skip: (page - 1) * PAGINATION_LIMIT, limit: PAGINATION_LIMIT },
    });

    if (res) {
      let transformedData = res.data.map((items) => ({
        id: items.id,
        code: items.code,
        amount: spliter(items.amount),
        type: items.type === "percentage" ? "درصد" : "تومان",
        expires_at: items.expires_at.jdate.split(" ")[0],
        delete: (
          <IconButton size="medium" onClick={() => deleteDiscount(items.id)}>
            <MdDelete size={24} />
          </IconButton>
        ),
      }));

      setDiscount({ data: transformedData, count: res.count });
    }
  }, [page, request, deleteDiscount]);

  var deleteDiscount = useCallback(
    async (id) => {
      const res = await request({
        url: deleteDiscountRequest,
        values: id,
      });
      if (res) {
        getDiscount();
        Toast({
          type: "success",
          title: "حذف تخفیف ",
        });
      }
    },
    [getDiscount, request]
  );
  useEffect(() => {
    getDiscount();
  }, [page, getDiscount]);
  return (
    <DrawerCM title="کد تخفیف">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2} spacing={1}>
          <Grid item xs={12} my={2}>
            <TableCM
              title="کد های تخفیف ثبت شده"
              rows={discount.data}
              headCells={headCells}
              addDiscount
              page={page}
            />
          </Grid>
          <PaginationCM
            handleChange={(e, val) => {
              initialPage = val;
              setPage(val);
            }}
            page={page}
            count={discount.count}
          />
        </Grid>
      )}
    </DrawerCM>
  );
}
